// reducers/index.js
import { combineReducers } from 'redux'; 
import homePageReducer from './homePageReducer';
const rootReducer = combineReducers({ 
  Home: homePageReducer,
});

export default rootReducer;
